module.exports = __webpack_public_path__ + "static/media/report-damage-graphic.4434f797.png";